/**
 * Campo de contraseña con ojito para mostrar/ocultar.
 *
 * Un campo a ciegas es donde la gente teclea mal y no sabe por qué no entra.
 * Reutilizable: login, registro, restablecer. El botón NO es tabbable
 * (tabIndex -1) para no estorbar el flujo de teclado hacia el submit.
 */
import { InputHTMLAttributes, useState } from 'react';
import { Icon } from './Icon';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  inputClassName?: string;
};

export function PasswordField({ inputClassName = 'field bg-surface', ...props }: Props) {
  const [show, setShow] = useState(false);
  return (
    <span className="relative block">
      <input
        {...props}
        type={show ? 'text' : 'password'}
        className={`${inputClassName} pr-12`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        aria-pressed={show}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-3 hover:text-ink grid place-items-center h-8 w-8"
      >
        <Icon name={show ? 'eye-off' : 'eye'} size={19} strokeWidth={1.8} />
      </button>
    </span>
  );
}
